import type { BuildingSocietySavingsSettingsDetailsCountryConfig } from '../../BuildingSocietySavingsSettingsDetailsConfig';

export const savingsSettingsDetails: BuildingSocietySavingsSettingsDetailsCountryConfig = {
    displayIban: true,
    displaySlashedBBAN: true,
    displayBic: true,
};
